import {defineAsyncComponent} from 'vue';
const PostedBatch = defineAsyncComponent(() => import('@/views/utility/PostedBatch.vue'));
const PostedBatchResult = defineAsyncComponent(() => import('@/views/utility/PostedBatchResult.vue'));
const ViewVoucherReference = defineAsyncComponent(() => import('@/views/utility/ViewVoucherReference.vue'));
const DataMantainance = defineAsyncComponent(() => import('@/views/utility/DataMantainance.vue'));
const DataMantainanceResult = defineAsyncComponent(() => import('@/views/utility/DataMantainanceResult.vue'));
const ShortcutList = defineAsyncComponent(() => import('@/views/utility/shortcut/ShortcutList.vue'));
const ShortcutDetail = defineAsyncComponent(() => import('@/views/utility/shortcut/ShortcutDetail.vue'));
// form show kết quả ghi sổ/ bỏ ghi sổ theo lô
const PostedBatchResults = defineAsyncComponent(() => import('@/views/utility/PostedBatchResults.vue'));
// Chứng từ hiện thời
const DuplicateVoucher = defineAsyncComponent(() => import('@/views/budgetPlan/buTransfer/popup/DuplicateVoucher.vue'));
const UtilityCopyVoucherPopup = defineAsyncComponent(() =>
  import('@/views/utility/voucher/UtilityCopyVoucherPopup.vue'),
);
const UpdateAccountCopyVoucherPopup = defineAsyncComponent(() =>
  import('@/views/utility/voucher/UpdateAccountCopyVoucherPopup.vue'),
);

const GenerateAccountingPaymentBudget = defineAsyncComponent(() =>
  import('@/views/utility/voucher/GenerateAccountingPaymentBudget.vue'),
);
// Sao chép chứng từ Hạch toán chi phí Lương
const DuplicateVoucherSaSalaryAccounting = defineAsyncComponent(() =>
  import('@/views/salary/accounting/popup/DuplicateVoucherSaSalaryAccounting.vue'),
);

// Sinh hạch toán chi phí lương, bảo hiểm, KPCĐ
const GenerateExpenseAccountingPopup = defineAsyncComponent(() =>
  import('@/views/utility/generateExpenseAccounting/GenerateExpenseAccountingPopup.vue'),
);

// Sinh phiếu chi
const GeneratePaymentVoucherResultPopup = defineAsyncComponent(() =>
  import('@/views/utility/generatePaymentVoucher/GeneratePaymentVoucherResultPopup.vue'),
);
// kết quả sinh phiếu chi hàng loạt
const PostedVoucherPaymentResult = defineAsyncComponent(() =>
  import('@/views/utility/generatePaymentVoucher/PostedVoucherPaymentResult.vue'),
);

// popup cập nhật thông tư 23/2023
const popupNoticeUpdateCircularTT23 = defineAsyncComponent(() =>
  import('@/views/utility/updateCircular23/NoticeUpdateCircularTT23.vue'),
);
const popupUpdateCircular23 = defineAsyncComponent(() =>
  import('@/views/utility/updateCircular23/UpdateCircular23.vue'),
);
const popupSelectFACategory = defineAsyncComponent(() =>
  import('@/views/utility/updateCircular23/SelectFACategory.vue'),
);
//Cập nhật chứng từ liên quan phiếu chi
const UpdatePaymentVoucherPopup = defineAsyncComponent(() =>
  import('@/views/utility/generatePaymentVoucher/UpdatePaymentVoucherPopup.vue'),
);

//Form chọn năm và nguồn lập dự toán chi
const budgetPlanChooseSource = defineAsyncComponent(() =>
  import('@/views/utility/BudgetPlanSource/BudgetPlanChooseSource.vue'),
);

// Lập hồ sơ kho bạc điện tử từ chứng từ đã hạch toán
const DocumentationInfoPopup = defineAsyncComponent(() =>
  import('@/views/utility/prepareDocumenttation/DocumentationInfoPopup.vue'),
);
const ConnectDvc = defineAsyncComponent(() => import('@/views/utility/prepareDocumenttation/ConnectDVC.vue'));

const ReportSortInfoPopup = defineAsyncComponent(() => import('@/views/utility/ReportSortInfoPopup.vue'));

const popupSelectBuPlanReceipt = defineAsyncComponent(() => import('@/views/utility/SelectBuPlanReceipt.vue'));
const PreviewDescriptionReport = defineAsyncComponent(() => import('@/views/utility/PreviewDescriptionReport.vue'));

//  Popup xuất dữ liệu sang STC Hải Dương
const ExportDataSTCHaiDuongPopup = defineAsyncComponent(() =>
  import('@/views/utility/exportDataSTCHaiDuong/ExportDataSTCHaiDuong.vue'),
);

export function registerUtility(app) {
  app.component('PostedVoucher', PostedBatch);
  app.component('PostedBatchResult', PostedBatchResult);
  app.component('ViewVoucherReference', ViewVoucherReference);
  app.component('DataMantainance', DataMantainance);
  app.component('DataMantainanceResult', DataMantainanceResult);
  app.component('ShortcutList', ShortcutList);
  app.component('ShortcutDetail', ShortcutDetail);
  app.component('DuplicateVoucher', DuplicateVoucher);
  app.component('UtilityCopyVoucherPopup', UtilityCopyVoucherPopup);
  app.component('UpdateAccountCopyVoucherPopup', UpdateAccountCopyVoucherPopup);
  app.component('DuplicateVoucherSaSalaryAccounting', DuplicateVoucherSaSalaryAccounting);
  app.component('GenerateExpenseAccountingPopup', GenerateExpenseAccountingPopup);
  app.component('GeneratePaymentVoucherResultPopup', GeneratePaymentVoucherResultPopup);
  app.component('PostedVoucherPaymentResult', PostedVoucherPaymentResult);
  app.component('PostedBatchResults', PostedBatchResults);
  app.component('UpdateCircular23', popupUpdateCircular23);
  app.component('NoticeUpdateCircularTT23', popupNoticeUpdateCircularTT23);
  app.component('SelectFACategory', popupSelectFACategory);
  app.component('UpdatePaymentVoucherPopup', UpdatePaymentVoucherPopup);
  app.component('BudgetPlanChooseSource', budgetPlanChooseSource);
  app.component('DocumentationInfoPopup', DocumentationInfoPopup);
  app.component('ConnectDvc', ConnectDvc);
  app.component('ReportSortInfoPopup', ReportSortInfoPopup);
  app.component('PreviewDescriptionReport', PreviewDescriptionReport);
  app.component('SelectBuPlanReceipt', popupSelectBuPlanReceipt);
  app.component('ExportDataSTCHaiDuongPopup', ExportDataSTCHaiDuongPopup);
  app.component('GenerateAccountingPaymentBudget', GenerateAccountingPaymentBudget);
}
